export const badgeColors = [
  "gray",
  "brand",
  "error",
  "warning",
  "success",
  "gray-blue",
  "blue-light",
  "blue",
  "indigo",
  "purple",
  "pink",
  "orange",
] as const;

export const tailwindColorClasses: {
  [C in (typeof badgeColors)[number]]: string;
} = {
  gray: "bg-gray-v2-50 border-gray-v2-200 text-gray-v2-700",
  brand: "bg-brand-v2-50 border-brand-v2-200 text-brand-v2-700",
  error: "bg-error-v2-50 border-error-v2-200 text-error-v2-700",
  warning: "bg-warning-v2-50 border-warning-v2-200 text-warning-v2-700",
  success: "bg-success-v2-50 border-success-v2-200 text-success-v2-700",
  "gray-blue":
    "bg-gray-blue-v2-50 border-gray-blue-v2-200 text-gray-blue-v2-700",
  "blue-light":
    "bg-blue-light-v2-50 border-blue-light-v2-200 text-blue-light-v2-700",
  blue: "bg-blue-v2-50 border-blue-v2-200 text-blue-v2-700",
  indigo: "bg-indigo-v2-50 border-indigo-v2-200 text-indigo-v2-700",
  purple: "bg-purple-v2-50 border-purple-v2-200 text-purple-v2-700",
  pink: "bg-pink-v2-50 border-pink-v2-200 text-pink-v2-700",
  orange: "bg-orange-v2-50 border-orange-v2-200 text-orange-v2-700",
};

export const tagColorClasses: {
  [C in (typeof badgeColors)[number]]: string;
} = {
  gray: "text-gray-v2-500",
  brand: "text-brand-v2-500",
  error: "text-error-v2-500",
  warning: "text-warning-v2-500",
  success: "text-success-v2-500",
  "gray-blue": "text-gray-blue-v2-500",
  "blue-light": "text-blue-light-v2-500",
  blue: "text-blue-v2-500",
  indigo: "text-indigo-v2-500",
  purple: "text-purple-v2-500",
  pink: "text-pink-v2-500",
  orange: "text-orange-v2-500",
};
